import script from "./QuestionContentComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionContentComponent.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionContentComponent.vue?vue&type=style&index=0&id=5ff6710c&lang=scss&scoped=true"
import "./QuestionContentComponent.vue?vue&type=style&index=1&id=5ff6710c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff6710c"]])

export default __exports__